/* ===== src/utils/generatePdf.ts ===== */
import { apiRequest } from '../../services/api';
import { ProjectState } from '../types/project';

export async function generatePdf(
  projectState: ProjectState, 
  selectedSections: any = { 
    frontMatter: { enabled: true }, 
    chapters: { enabled: true }, 
    backMatter: { enabled: true } 
  },
  includeBackground: boolean = true
): Promise<Blob> {
  try {
    const response = await apiRequest('/api/export/pdf', 'POST', {
      projectId: projectState.projectId,
      selectedSections,
      includeBackground
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to generate PDF');
    }

    return await (response as any).blob();
  } catch (error) {
    console.error('PDF generation error:', error);
    throw error;
  }
}